import * as React from "react";
const SvgFlashOn = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 2v11h3v9l7-12h-4l3-8z",
  fill: "currentColor"
}));
export default SvgFlashOn;